import React from 'react';
import { SolutionDetailTemplate } from '../shared/SolutionDetailTemplate';

export const DigitalTransformationITEnablementPage: React.FC = () => {
  return (
    <SolutionDetailTemplate
      title="Digital Transformation & IT Enablement"
      description="Custom software and web solutions that are scalable, secure, and aligned with business objectives to drive digital transformation."
      category="Digital Solutions"
      categoryColor="#ff6b6b"
      keyFeatures={[
        "Custom dashboards, portals, and integrations",
        "Responsive, SEO-optimized, and high-performance websites",
        "Seamless cross-device accessibility",
        "Cloud-native architecture and deployment",
        "API-first development approach",
        "Enterprise-grade security and scalability"
      ]}
      benefits={[
        "Accelerate digital transformation initiatives",
        "Improve operational efficiency through automation",
        "Enhance customer experience and engagement",
        "Reduce IT infrastructure and maintenance costs",
        "Enable rapid scaling and business growth",
        "Streamline business processes and workflows",
        "Future-proof technology investments"
      ]}
      useCases={[
        "Enterprise resource planning (ERP) systems",
        "Customer relationship management (CRM) platforms",
        "E-commerce and digital marketplace development",
        "Learning management systems (LMS)",
        "Human resource management systems (ManageRTC)",
        "Project management and collaboration tools",
        "Business intelligence and analytics dashboards",
        "Mobile applications and progressive web apps"
      ]}
      relatedTools={[
        {
          name: "ManageRTC",
          description: "Modern HR stack with integrations (IDP, payroll, job boards).",
          href: "/products/it/manageRTC"
        },
        {
          name: "Planfusion",
          description: "Unified lead/CRM layer with analytics and connectors.",
          href: "/products/ai/planfusion"
        },
        {
          name: "Learning Management Platform",
          description: "Content authoring, skills tracking, and compliance training at scale.",
          href: "/products/ai/LearningManagementSystem"
        },
        {
          name: "Whishperagon",
          description: "AI layer for support channels and internal service desks.",
          href: "/products/ai/whisperagon"
        },
        {
          name: "Real Estate",
          description: "Digitized listings, CRM, valuation, and transaction workflows.",
          href: "/products/real-estate"
        },
        {
          name: "Crypto Trading Platform",
          description: "Digital‑asset rails, wallets, and compliance integrations.",
          href: "/products/ai/cryptotradingplatform"
        },
        {
          name: "GreenH2 ",
          description: "Ops platform for hydrogen production monitoring, forecasting, and optimization.",
          href: "/products/greenh2"
        },
        {
          name: "Genesequer",
          description: "Data/analytics platform for bioinformatics pipelines.",
          href: "/products/ai/geneseqer"
        },
        {
          name: "Style Sync ",
          description: "Commerce enablement for personalization and creation workflows.",
          href: "/products/style-sync"
        },
        {
          name: "AI Cooler",
          description: "Connected product with IoT telemetry and OTA control.",
          href: "/products/ai/aicooler"
        },
        {
          name: "Tawjih.AI ",
          description: " AI decisioning layer for digital channels and risk ops.",
          href: "/products/ai/tawjihai"
        },
        {
          name: "Predictive Maintenance",
          description: "IoT + analytics stack for asset‑heavy operations.",
          href: "/products/ai/predictivemaintenance"
        },
        {
          name: "Water Level IoT",
          description: "Lightweight IoT telemetry and dashboards.",
          href: "/products/iot/water-level-iot"
        },
        {
          name: "Finance Policy Check",
          description: "Finance ops enablement with ERP/ledger integrations.",
          href: "/products/ai/financepolicycheck"
        }
      ]}
      industries={[
        "Technology & IT Services",
        "Education & Research",
        "Retail & E-commerce",
        "Banking & Financial Services",
        "Healthcare & Life Sciences"
      ]}
    />
  );
};